import endpoint from "@/api/endpoint";

export default {

    all(data) {
        return window.axios.get(endpoint + '/api/project/' + data.id + '/communication_plan', data);
    },

    store(data) {
        return window.axios.post(endpoint + '/api/project/' + data.project_id + '/communication_plan', data);
    },

    update(data) {
        return window.axios.post(endpoint + '/api/project/' + data.project_id + '/communication_plan/' + data.id, data);
    },

    delete(data) {
        return window.axios.delete(endpoint + '/api/project/' + data.project_id + '/communication_plan/' + data.id, data);
    },

}
